<div class="row">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-12">
                <label for="url" class="control-label">
                    URL&nbsp;
                    <ng-container *ngIf="ludSelecionado">
                        <img src="/favicon-normas.ico" class="icon-normas" *ngIf="ludSelecionado.tipo === 1" title="Ato do Normas">
                        <em class="material-icons icon-18" *ngIf="ludSelecionado.tipo === 2" title="Recurso externo">language</em>
                        <span (click)="alternarUrlNormas()" *ngIf="ludSelecionado.tipo === 1">
                            <em class="material-icons icon-18 cadeado-fechado" *ngIf="!linkInternoNormas" title="Consulta externa">lock_open</em>
                            <em class="material-icons icon-18 cadeado-aberto" *ngIf="linkInternoNormas" title="Consulta interna">https</em>
                        </span>
                    </ng-container>
                </label>
                <input type="text" id="url" class="form-control" [(ngModel)]="url">
            </div>
        </div>
        <div class="row">
            <div class="col-sm-2">
                <label for="fragmento" class="control-label">Fragmento #</label>
                <input type="text" id="fragmento" class="form-control" [(ngModel)]="fragmento">
            </div>
            <div class="col-sm-4">
                <label for="dispositivo" class="control-label">Dispositivo</label>
                <input type="text" id="dispositivo" class="form-control" [(ngModel)]="dispositivo" readonly>
            </div>
            <div class="col-sm-6">
                <label class="control-label">&nbsp;</label>
                <div class="form-group" class="botoes-a-direita">
                    <button type="button" class="btn btn-default btn-sm" [disabled]="verificarUrlNaoInformado()" (click)="testarUrl()">Testar</button>
                    <ng-container *ngIf="!isGerirRecursos">
                        <button type="button" class="btn btn-default btn-sm" (click)="descartarLud()">Descartar LUD</button>
                        <button type="button" class="btn btn-default btn-sm" [disabled]="verificarUrlNaoInformado()" (click)="confeccionarLud()">Confirmar</button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

